import * as React from "react";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

import {
  withStyles,
  Typography,
  IconButton,
  makeStyles,
  Theme,
  createStyles,
  Tooltip
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const styles = (theme: {
  spacing: {
    (arg0: number): void;
    (arg0: number): void;
    (arg0: number): void;
  };
  palette: { grey: any[] };
}) => ({
  root: {
    margin: 0,
    paddingLeft: "20px",
    width: "500px",
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogHead: {
      height: "18px",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: 1.29,
      letterSpacing: "normal",
      color: "#32325d"
    },
    wh_16: {
      width: "16px !important",
      height: "16px !important"
    }
  })
);

export const DialogTitle = withStyles(styles as any)(
  (props: { [x: string]: any; children: any; classes: any; onClose: any }) => {
    const classNew = useStyles();
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6" className={`${classNew.dialogHead}`}>
          {children}
        </Typography>
        {onClose ? (
          <Tooltip title={"Close"}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon className={classNew.wh_16} />
            </IconButton>
          </Tooltip>
        ) : null}
      </MuiDialogTitle>
    );
  }
);
